import httpService from '@/utils/request'
import { contextPath } from '@/config/'

export const queryDataManageListApi = (params) => {
  return httpService({
    url: contextPath + '/data/spider/storage/new/page',
    method: 'get',
    params
  })
}

export const downloadAllApi = (params) => {
  return httpService({
    url: contextPath + '/data/spider/storage/new/downloadAll',
    method: 'get',
    params
  })
}

export const downloadBatchApi = (params) => {
  return httpService({
    url: contextPath + '/data/spider/storage/new/downloadBatch',
    method: 'get',
    params
  })
}

export const getDownStatisticsApi = (params) => {
  return httpService({
    url: contextPath + '/data/down/statistics/page',
    method: 'get',
    params
  })
}